import { useNavigate, Link } from "react-router-dom";
import "./Home.css";

export default function Home({ setPopUpWindow }) {
    const navigate = useNavigate();

    return (
        <div className="home-container">
            
            <div className="home-hero">
                <div className="hero-text-container">
                    <span>A quick guide before you sign up</span>
                    <h1>How classes work</h1>
                    <p>My classes are listed on the monthly calendar. You can sign up one at a time, or add several to your shopping cart and book them together.</p>
                </div>
                <div className="hero-img-container">
                    <img src="/kitty_welcome.png" alt="Welcome!"></img>
                </div>
                <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
                    <path d="M0,40 C360,110 1080,-30 1440,50 L1440,100 L0,100 Z"/>
                </svg>
            </div>

            <div className="home-description">

                <div>
                    <h2>As flexible as you need</h2>
                    <img className="description-img-1" src="/img-calendar.png" alt="Calendar"></img>
                </div>
                <p>
                    You set the pace by signing up for the classes that work for you. Some students come several times a week, others once or twice, and some drop in whenever they can.
                    <br></br><br></br>
                    Before every class, I check who’s coming and plan something that suits that particular group. I want each session to be enjoyable and useful for everyone, while making sure we’re never doing exactly the same thing twice.
                </p>
                <img className="description-img-2" src="/img-plant.png" alt="Flexible"></img>

            </div>

            <div className="home-separator-title">
                <h2>-----</h2>
                <h3>Types of Classes</h3>
                <h2>-----</h2>
            </div>

            <div className="home-cards">

                <div className="card-container">
                    <img src="/round-icon-conversation.png" alt="Intermediate"></img>
                    <div className="card-text-container">
                        <h2>
                            Intermediate Speaking Classes
                        </h2>
                        <p>
                            Focused on speaking and communication, with a different theme each class — phrasal verbs, telling stories, sharing opinions, talking about experiences. See the current schedule of topics.
                            <br></br><br></br>We learn new vocabulary, then put it to work through roleplays, discussions, problem-solving activities, or questions we come up with for each other. The goal is lots of practice in a comfortable small-group setting, actually using what we’re learning.
                            <br></br><br></br>Every class has a prepared presentation or set of activities, usually several tasks in one session. Afterwards, you’ll get detailed notes and a written assignment to keep practicing.
                        </p>
                        <button className="card-button" onClick={() => navigate("/agenda")}>
                            <span>Book a Class</span>
                        </button>
                    </div>
                </div>

                {/* HOME BUTTONS IN CARD SECTION */}
                <div className="home-buttons">
                    <Link className="button-style" to="https://docs.google.com/document/d/1EcF0CLMqJnRG5e8jlKf06E8KJA4EQtVBaDRQpEukqSc/edit?usp=sharing">
                        <img src="button-calendar.png" alt="Topics"></img>
                        <span>See the current schedule of topics</span>
                        <img src="/button-arrow-right.png" alt="Visit"></img>
                    </Link>
                    <Link className="button-style button-green-bg" to="https://test-english.com/level-test/">
                        <img src="/button-level.png" alt="Level"></img>
                        <span>Not sure about your level? Take this quick test.</span>
                        <img src="/button-arrow-right.png" alt="Visit"></img>
                    </Link>
                </div>

                <div className="card-container">
                    <img src="/round-icon-advanced.png" alt="Advanced"></img>
                    <div className="card-text-container">
                        <h2>
                            Advanced English
                        </h2>
                        <p>
                            Designed for students who want to sharpen their language skills and writing.
                            <br></br><br></br>We work with more challenging texts — articles, poems, short stories. Read beforehand and note useful vocabulary in your lexical chunk log, then in class we discuss and analyze the text together, its language as well as its ideas and interpretations.
                            <br></br><br></br>Afterwards, you'll write a short blog post about the topic. This class is for students who want to really push their English further.
                        </p>
                        <button className="card-button" onClick={() => navigate("/agenda")}>
                            <span>Book a Class</span>
                        </button>
                    </div>
                </div>

                <div className="card-container">
                    <img src="/round-icon-work.png" alt="Work"></img>
                    <div className="card-text-container">
                        <h2>
                            English for Work
                        </h2>
                        <p>
                            Practical English for real work situations, including job interviews, meetings, presentations, professional conversations. You'll get assignments outside class, including recorded voice notes, and we stay in touch and keep each other motivated through a WhatsApp group.
                        </p>
                        <button className="card-button" onClick={() => navigate("/agenda")}>
                            <span>Book a Class</span>
                        </button>
                    </div>
                </div>

                <div className="card-container">
                    <img src="/round-icon-book.png" alt="Book"></img>
                    <div className="card-text-container">
                        <h2>
                            Book Groups
                        </h2>
                        <p>
                            We read a book together, then meet to talk about it, share opinions, and dig into the language. Send a message if you'd like to join the next one.
                        </p>
                        <button className="card-button" onClick={() => navigate("/agenda")}>
                            <span>Book a Class</span>
                        </button>
                    </div>
                </div>

                <div className="card-container">
                    <img src="/round-icon-coaching.png" alt="Coaching"></img>
                    <div className="card-text-container">
                        <h2>
                            1-to-1 Coaching
                        </h2>
                        <p>
                            For students with a specific goal: preparing for an interview or presentation, practicing for a meeting, working on a particular area of English, or just getting focused speaking practice. Every session is tailored to what you need.
                        </p>
                        <button className="card-button" onClick={() => navigate("/agenda")}>
                            <span>Book a Class</span>
                        </button>
                    </div>
                </div>

            </div>

            <div className="home-separator-title">
                <h2>-----</h2>
                <h3>Payment</h3>
                <h2>-----</h2>
            </div>

            <div className="home-payment">
                <p>
                    Book and pay by credit card through my website, or with WISE.
                </p>
                <img src="/round-icon-payment.png" alt="Payment"></img>
            </div>

            <div className="home-questions">
                <p>
                    Questions about which class is right for you? Just <span tabIndex={0} onClick={() => {navigate("/contacto")}}>send a message ✉️</span>.
                </p>
                <img src="/kitty_satisfied.png" alt="Message me!"></img>
            </div>

            <div className="home-footer">
                <a href="https://www.instagram.com/charmenglishcl">
                    <img src="/icon-instagram.png" alt="Instagram"></img>
                </a>
                <a href="https://www.tiktok.com/@charmenglishcl">
                    <img src="/icon-tiktok.png" alt="TikTok"></img>
                </a>
                <a href="https://open.spotify.com/show/2SEL92v1KjWVz08odARJ05">
                    <img src="/icon-spotify.png" alt="Spotify"></img>
                </a>
                <a href="https://www.youtube.com/@CharmEnglishMaggie">
                    <img src="/icon-youtube.png" alt="YouTube"></img>
                </a>
                <a href="https://substack.com/@charmenglishcl">
                    <img src="/icon-substack.png" alt="SubStack"></img>
                </a>
                <a href="https://buymeacoffee.com/maggiecars3">
                    <img src="/icon-buymeacoffee.png" alt="Buy me a Coffe"></img>
                </a>
            </div>

        </div>
    )
};